export enum AccountType {
  Team = 'team',
  Personal = 'personal',
}

export enum OrganizationLicense {
  Full = 'Full',
  Guest = 'Guest',
}
